import  Oidc from 'oidc-client';
import * as config from '@/utils/config';

const stagingAuthority = config.STAGING_AUTHORITY;
const wsSettings: Oidc.WebStorageStateStoreSettings = {};

export const authManager = new Oidc.UserManager({
    userStore: new Oidc.WebStorageStateStore(wsSettings),
    authority: stagingAuthority,
    client_id: config.CLIENT_ID,
    //client_secret: config.CLIENT_SECRET,
    redirect_uri: config.REDIRECT_URI,
    silent_redirect_uri: config.SILENT_REDIRECT_URI,
    response_type: 'id_token token',
    //scope: 'openid profile all_claims',
    post_logout_redirect_uri: config.POST_LOGOUT_REDIRECT_URI,
    loadUserInfo: true,
    automaticSilentRenew: true,
});

//export let userObj: any;
// export let signedIn = false;
const mgr = authManager;

export const signIn = () => {
    mgr.signinRedirect().catch((err) => {
        console.log(err);
    });
};

export const signOut = () => {
//   var self = this;
    mgr.signoutRedirect().then((resp) => {
        // signedIn = false;
        console.log('signed out', resp);
    }).catch((err) => {
        console.log(err);
    });
};

mgr.events.addAccessTokenExpiring(() => {
    console.log('AccessToken Expiring ...');
    mgr.signinSilent()
        .then(() => {
            console.log('Silent sign in completed.')
        })
        .catch(error => {
            console.error('Error in silent sign-in.', error);
            alert('Sessione scaduta. Esegui di nuovo il login.');
            mgr.signoutRedirect().then((resp) => {
                console.log('signed out', resp);
            }).catch((err) => {
                console.log(err);
            });
        });
});

mgr.events.addAccessTokenExpired(() => {
    console.log('Sessione scaduta!');
    alert('Sessione scaduta. Esegui di nuovo il login.');
    mgr.signoutRedirect().then((resp) => {
        console.log('signed out', resp);
    }).catch((err) => {
        console.log(err);
    });
});

mgr.events.addSilentRenewError(() => {
    console.error('Silent Renew Error：');
    alert('Sessione scaduta. Esegui di nuovo il login.');
    mgr.signoutRedirect().then((resp) => {
        console.log('signed out', resp);
    }).catch((err) => {
        console.log(err);
    });
});
